import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import App from './components/App.js'
import './i18n';
ReactDOM.render(
    <Suspense fallback={(<div></div>)}>
        <App></App>
    </Suspense>, document.getElementById('root'));
